import React from 'react';
import styled from 'astroturf/react';
import $image_url from 'js/utils/image_url';

import Carousel, { CarouselProps } from '../shared/Carousel';
import SignUpButton from '../shared/SignUpButton';
import { userSentimentPopup } from './course_discovery_helper';

export interface Props {
  carousels: Array<CarouselProps>;
  showUserSentimentPopup?: boolean;
}

const TopSectionOuterContainer = styled.div`
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 0px 16px;

  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    padding: 0px 50px;
  }
`;

const TopSectionInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1130px;
  justify-content: space-between;

  padding-top: 30px;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }

  @media screen and (min-width: 1024px) {
    padding-top: 38px;
  }

  @media screen and (min-width: 1366px) {
    margin: 0 auto;
  }

  @media screen and (min-width: 768px) {
    padding-bottom: 38px;
  }
`;

const TopSectionDetailsContainer = styled.div`
  margin-bottom: 48px;
`;

const TopSectionHeader = styled.div`
  margin-bottom: 8px;
  font-family: Roboto;
  font-weight: bold;
  font-size: 34px;
  line-height: 40px;
  color: #222222;
  @media screen and (min-width: 800px) {
    width: 410px;
  }
`;

const TopSectionSubHeader = styled.div`
  margin-bottom: 40px;
  font-family: Roboto;
  font-size: 24px;
  line-height: 31px;

  color: #222222;

  opacity: 0.9;
`;

const TopSectionImagesContainer = styled.div`
  display: none;
  height: 315px;
  width: 455px;
  position: relative;
  z-index: 0;

  @media screen and (min-width: 800px) {
    display: inline;
  }
`;

const Rectangle = styled.div`
  position: absolute;
  width: 378.5px;
  height: 161.18px;
  border-radius: 4px;
  background-color: #d8e5f9;

  right: 0px;
  top: 98px;

  @media screen and (max-width: 900px) {
    width: 270px;
    top: 80px;
  }
`;

const Image1 = styled.img`
  position: absolute;
  width: 280px;
  right: 71px;
  z-index: 1;
  border-radius: 4px;

  @media screen and (max-width: 900px) {
    width: 200px;
    right: 30px;
    top: 30px;
  }
`;

const Image2 = styled.img`
  position: absolute;
  width: 205px;
  bottom: 0px;
  z-index: 1;
  border-radius: 4px;

  @media screen and (max-width: 900px) {
    width: 150px;
    bottom: 40px;
    left: 60px;
  }
`;

const CoursesContainer = styled.div`
  background: #f8f8f8;
  padding: 48px 0;
`;

const BottomSectionContainer = styled.div`
  background: #fff;
  border-top: 1px solid #dddddd;

  padding: 40px 16px 50px 16px;

  @media screen and (min-width: 1024px) {
    padding: 40px 50px 50px 50px;
  }
`;

const BottomSectionInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  max-width: 1130px;
  margin: 0 auto;

  @media screen and (min-width: 800px) {
    flex-direction: row;
  }
`;

const BottomSectionDetailsContainer = styled.div`
  flex-direction: column;
  padding-top: 28px;
`;

const BottomSectionHeader = styled.div`
  font-family: Roboto;
  font-size: 28px;
  line-height: 38px;
  margin-bottom: 5px;

  color: #222222;

  opacity: 0.9;
`;

const BulletContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

const BulletIcon = styled.i`
  margin-right: 10px;
  align-self: center;
  color: #0954d3;
  font-size: 25px;
`;

const BulletText = styled.div`
  font-family: Roboto;
  font-size: 20px;
  line-height: 24px;

  display: flex;
  align-items: center;

  color: #222222;

  opacity: 0.9;
`;

const BottomSectionCoursePageImage = styled.img`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ddd;
  @media screen and (min-width: 800px) {
    width: 398px;
    height: 318px;
    margin-left: 30px;
  }
  @media screen and (min-width: 1024px) {
    width: 500px;
    height: 388px;
  }
  @media screen and (min-width: 1366px) {
    width: 600px;
    height: 466px;
  }
`;

const BottomSignUpButtonContainer = styled.div`
  margin-top: 38px;
  margin-bottom: 40px;

  @media screen and (min-width: 768px) {
    margin-top: 48px;
  }
`;

export default function LoggedOutDiscoveryPage(props: Props) {
  const { carousels, showUserSentimentPopup } = props;
  const sections = carousels.map((carouselProps, idx) => {
    return (
      <Carousel
        key={idx}
        categoryTitle={carouselProps.categoryTitle}
        courses={carouselProps.courses}
        page={'discoveryLoggedOut'}
        courseImpressionData={carouselProps.courseImpressionData}
      />
    );
  });

  return (
    <>
      <TopSectionOuterContainer>
        <TopSectionInnerContainer>
          <TopSectionDetailsContainer>
            <TopSectionHeader>
              Accelerate your career with courses
            </TopSectionHeader>
            <TopSectionSubHeader>
              Taught by leading academics
            </TopSectionSubHeader>
            <SignUpButton />
          </TopSectionDetailsContainer>
          <TopSectionImagesContainer>
            <Image1 src={$image_url('course-page-image-1.jpg')} />
            <Image2 src={$image_url('course-page-image-2.jpg')} />
            <Rectangle />
          </TopSectionImagesContainer>
        </TopSectionInnerContainer>
      </TopSectionOuterContainer>
      {carousels && <CoursesContainer>{sections}</CoursesContainer>}
      <BottomSectionContainer>
        <BottomSectionInnerContainer>
          <BottomSectionDetailsContainer>
            <BottomSectionHeader>
              Learn at your own pace and achieve your goals
            </BottomSectionHeader>
            <BulletContainer>
              <BulletIcon className="fa fa-check" />
              <BulletText>Watch courses on your own schedule</BulletText>
            </BulletContainer>
            <BulletContainer>
              <BulletIcon className="fa fa-check" />
              <BulletText>Learn from leading experts</BulletText>
            </BulletContainer>
            <BulletContainer>
              <BulletIcon className="fa fa-check" />
              <BulletText>Achieve professional success</BulletText>
            </BulletContainer>
            <BottomSignUpButtonContainer>
              <SignUpButton />
            </BottomSignUpButtonContainer>
          </BottomSectionDetailsContainer>
          <BottomSectionCoursePageImage
            src={$image_url('course-player-page.png')}
          />
        </BottomSectionInnerContainer>
      </BottomSectionContainer>
      {showUserSentimentPopup && userSentimentPopup}
    </>
  );
}
